import React from 'react';

import {DropdownItem} from '../../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemChevron} from '../../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemChevron';
import {DropdownItemContent} from '../../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {DropdownItemIcon} from '../../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemIcon';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {ConversationBaseModel} from '../../../../../../models/api/conversationModel';
import {SafetyNetRequiredTaggingModel} from '../../../../../../models/api/safetyNetModel';
import {TagModel} from '../../../../../../models/api/tagModel';
import {RequiredTaggingDropdown} from './requiredTaggingDropdown';

/*
 * Props.
 */

interface AddRequiredTagItemProps {
  requiredTaggingSafetyNet: SafetyNetRequiredTaggingModel;
  conversations: ReadonlyArray<ConversationBaseModel>;
  index: number;
  onTagConversation: (model: TagModel) => void;
  onUntagConversation: (model: TagModel) => void;
}

/*
 * Component.
 */

export const AddRequiredTagItem: React.FC<AddRequiredTagItemProps> = (props) => {
  const {requiredTaggingSafetyNet, index, conversations, onTagConversation, onUntagConversation} = props;

  const renderButton = () => (
    <DropdownItem
      renderRightContent={() => <DropdownItemChevron />}
      onSelect={(selectEvent) => {
        selectEvent.preventDefault();
      }}
      index={index}
    >
      <DropdownItemIcon iconName="tags" label={null} />
      <DropdownItemContent>{requiredTaggingSafetyNet.name}</DropdownItemContent>
    </DropdownItem>
  );

  const renderDropdown = (popoverTransferProps: PopoverTransferProps) => (
    <RequiredTaggingDropdown
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...popoverTransferProps}
      requiredTaggingSafetyNet={requiredTaggingSafetyNet}
      conversations={conversations}
      onTagConversation={onTagConversation}
      onUntagConversation={onUntagConversation}
    />
  );

  return <PopoverCoordinator renderModal={renderDropdown} renderButton={renderButton} />;
};
